import { ContentSaveEditOutlineIcon } from './ContentSaveEditOutlineIcon';

/**
 * author: Michael Irigoyen
 * id B8D3719E-E67F-4008-9F43-458D75857769
 * name content-save-edit-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-edit-outline.svg
 * tags
 * - Edit / Modify 
 */
export const FloppyDiscEditOutlineIcon = ContentSaveEditOutlineIcon;
export default FloppyDiscEditOutlineIcon